// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","461":"b637e9a5","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"180d6a57a2d8d827357b","293":"062b09e85d2a8267d0ae","461":"f59b311dbef0691003d3","518":"242e7cb4b15532a82c71","779":"07aa9a94112e28fff1aa"}[chunkId] + ".js";
};